(function () {
  'use strict';

  var instancje = new WeakMap();
  var POWROT_SEGMENTU_MS = 130;

  function zdarzenie(nazwa, dane) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(nazwa, dane || {});
      }
    } catch (e) {}
  }

  function Start(korzen) {
    this.korzen = korzen;
    this.karty = [].slice.call(korzen.querySelectorAll('[data-bh-start-tab]'));
    this.tor = korzen.querySelector('.bh-start__choices');
    this.wskaznik = korzen.querySelector('.bh-start__choice-thumb');
    this.uchwyty = [];
    this.podlacz();
  }

  Start.prototype.nasluch = function (cel, nazwa, funkcja) {
    cel.addEventListener(nazwa, funkcja);
    this.uchwyty.push([cel, nazwa, funkcja]);
  };

  Start.prototype.podlacz = function () {
    var self = this;
    this.karty.forEach(function (karta) {
      var klucz = karta.getAttribute('data-bh-start-tab');
      if (klucz === 'czesc') self.nasluch(karta, 'click', function () { self.doWyszukiwarki(); });
      if (klucz === 'dobor') self.nasluch(karta, 'click', function () { zdarzenie('bramowe_home_start_drive_card', {}); });
    });
    this.nasluch(this.korzen, 'bh:drive:open', function () {
      self.anulujPowrot();
      self.ustawStan('dobor');
    });
    this.nasluch(this.korzen, 'bh:drive:zamykanie', function () {
      self.anulujPowrot();
      self.powrotSegmentu = window.setTimeout(function () {
        self.powrotSegmentu = null;
        self.ustawStan('czesc');
      }, POWROT_SEGMENTU_MS);
    });
    this.nasluch(this.korzen, 'bh:drive:close', function () {
      if (self.powrotSegmentu) return;
      self.ustawStan('czesc');
    });

    var zaplanowane = false;
    this.nasluch(window, 'resize', function () {
      if (zaplanowane) return;
      zaplanowane = true;
      window.requestAnimationFrame(function () {
        zaplanowane = false;
        self.ustawWskaznik(false);
      });
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.ustawWskaznik(false); });
    this.ustawWskaznik(false);
  };

  Start.prototype.anulujPowrot = function () {
    if (this.powrotSegmentu) window.clearTimeout(this.powrotSegmentu);
    this.powrotSegmentu = null;
  };

  Start.prototype.ustawStan = function (klucz) {
    this.karty.forEach(function (karta) {
      karta.setAttribute('aria-pressed', karta.getAttribute('data-bh-start-tab') === klucz ? 'true' : 'false');
    });
    this.ustawWskaznik(true);
  };

  Start.prototype.ustawWskaznik = function (zRuchem) {
    if (!this.tor || !this.wskaznik) return;
    if (window.getComputedStyle(this.wskaznik).display === 'none') return;
    var aktywna = null;
    for (var i = 0; i < this.karty.length; i += 1) {
      if (this.karty[i].getAttribute('aria-pressed') === 'true') aktywna = this.karty[i];
    }
    if (!aktywna) return;
    var rt = this.tor.getBoundingClientRect();
    var rk = aktywna.getBoundingClientRect();
    var tor = this.tor;
    if (!zRuchem) tor.classList.add('bh-start__choices--bez-ruchu');
    tor.style.setProperty('--bh-start-wskaznik-x', (rk.left - rt.left - tor.clientLeft) + 'px');
    tor.style.setProperty('--bh-start-wskaznik-w', rk.width + 'px');
    tor.classList.add('bh-start__choices--zmierzony');
    if (!zRuchem) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { tor.classList.remove('bh-start__choices--bez-ruchu'); });
      });
    }
  };

  Start.prototype.doWyszukiwarki = function () {
    var pole = this.korzen.querySelector('[data-bh-search-input]');
    if (pole) pole.focus({ preventScroll: true });
  };

  Start.prototype.rozlacz = function () {
    this.anulujPowrot();
    for (var i = 0; i < this.uchwyty.length; i += 1) {
      this.uchwyty[i][0].removeEventListener(this.uchwyty[i][1], this.uchwyty[i][2]);
    }
    this.uchwyty = [];
  };

  function przewin(el) {
    if (!el) return;
    if (window.BramoweHomeScroll) window.BramoweHomeScroll.doCelu(el);
    else el.scrollIntoView({ block: 'start' });
  }

  function otworzKreator(zrodlo, proba) {
    if (window.BramoweHomeDrive) {
      window.BramoweHomeDrive.otworz(zrodlo);
      return;
    }
    if ((proba || 0) < 40) {
      window.setTimeout(function () { otworzKreator(zrodlo, (proba || 0) + 1); }, 50);
    }
  }

  var ostatnieZadanie = { klucz: null, czas: 0 };

  function wykonaj(klucz, zrodlo) {
    var teraz = Date.now();
    if (klucz === ostatnieZadanie.klucz && teraz - ostatnieZadanie.czas < 500) return;
    ostatnieZadanie = { klucz: klucz, czas: teraz };

    if (klucz === 'dobor') {
      otworzKreator(zrodlo);
      return;
    }
    przewin(document.getElementById('bramowe-home-start'));
  }

  function zKotwicy() {
    var kotwica = (window.location.hash || '').replace('#', '');
    if (kotwica !== 'czesc' && kotwica !== 'dobor') return;
    wykonaj(kotwica, 'kotwica');
  }

  function przyKliknieciu(ev) {
    var link = ev.target.closest ? ev.target.closest('a[href="#czesc"], a[href="#dobor"]') : null;
    if (!link) return;
    var klucz = link.getAttribute('href').replace('#', '');
    var zrodlo = link.getAttribute('data-bh-zrodlo') || 'link';
    if (klucz === 'dobor') ev.preventDefault();
    if (zrodlo === 'hero') zdarzenie('bramowe_home_hero_drive_link', {});
    wykonaj(klucz, zrodlo);
  }

  function uruchom(zakres) {
    var korzenie = (zakres || document).querySelectorAll('[data-bh-start]');
    for (var i = 0; i < korzenie.length; i += 1) {
      if (instancje.has(korzenie[i])) continue;
      instancje.set(korzenie[i], new Start(korzenie[i]));
    }
    zKotwicy();
  }

  function zatrzymaj(zakres) {
    var korzenie = (zakres || document).querySelectorAll('[data-bh-start]');
    for (var i = 0; i < korzenie.length; i += 1) {
      var instancja = instancje.get(korzenie[i]);
      if (instancja) { instancja.rozlacz(); instancje.delete(korzenie[i]); }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { uruchom(); });
  } else {
    uruchom();
  }

  window.addEventListener('hashchange', zKotwicy);
  document.addEventListener('click', przyKliknieciu);
  document.addEventListener('shopify:section:load', function (ev) { uruchom(ev.target); });
  document.addEventListener('shopify:section:unload', function (ev) { zatrzymaj(ev.target); });
}());
